import { Link, useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { Achievement, AchievementCategory } from "../../../../../Entity/types/achievements.types";

import {
  EntityAchievementGalleryIcon,
  EntityInternationalTournamentIcon,
  EntityNationalLeagueIcon,
  EntityNationalTournamentIcon,
  EntityNationalCupIcon,
} from "../../../../assets/icons/entity-icons";
import { getEntityAchievementsRoute } from "../../../../../../routers/routeUtils";

interface AchievementCardProps {
  title: AchievementCategory;
  achievement: Achievement;
}

export const AchievementCard = ({ title, achievement: { id, name, count, imageCount } }: AchievementCardProps) => {
  const AchievementIconMapper = {
    "National league": <EntityNationalLeagueIcon />,
    "National cup": <EntityNationalCupIcon />,
    "National tournament": <EntityNationalTournamentIcon />,
    "International tournament": <EntityInternationalTournamentIcon />,
  };

  const { entityId } = useParams();
  return (
    <Box
      sx={{
        display: "flex",
        gap: "12px",
        borderRadius: "12px",
        border: "1px solid var(--Gray-200, #E4E7EC)",
        background: "var(--Base-White, #FFF)",
        padding: "16px",
        textDecoration: "none",
        gridColumn: "span 1",
      }}
      component={Link}
      to={getEntityAchievementsRoute(entityId!, id)}
    >
      {AchievementIconMapper[title]}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          sx={{
            color: "var(--Gray-600, #475467)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px",
          }}
        >
          {name}
        </Typography>
        <Typography
          sx={{
            color: "var(--Gray-900, #101828)",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          {count}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "4px",
          alignItems: "center",
          height: "fit-content",
        }}
      >
        <EntityAchievementGalleryIcon />
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "18px",
          }}
        >
          {imageCount}
        </Typography>
      </Box>
    </Box>
  );
};
